import { EmbedUser } from '../interfaces/user';

export interface FileUploadResponse {
  primaryKeyValue: string;
  orgIdValue: string;
  idPrefix: string;
  importRunId: null;
  fetchRunId: null;
  importType: string;
  parameters: Parameters;
  name: string;
  status: string;
  statusDetail: string;
  userId: string;
  lastRunDate: Date;
  lastStatusDate: Date;
  importResult: any[];
  processedCount: number;
  totalCount: number;
  orgId: string;
  rootOrgId: string;
  partnerId: null;
  _id: string;
  createdDate: Date;
  createdBy: EmbedUser;
  updatedDate: Date;
  updatedBy: EmbedUser;
  healthStatus: null;
  catchAll: null;
  customFields: null;
  isDeleted: null;
  deletedBy: null;
  deletedDate: null;
}

export interface Parameters {
  collection: string;
  orgId: string;
  import_id: string;
}

export enum FileUploadResponseStatusEnum {
  FileUploaded = 'FILE_UPLOADED',
  Failed = 'FAILED',
  FileReviewFailed = 'FILE_REVIEW_FAILED',
  IMPORTING = 'IMPORTING',
  COMPLETED = 'COMPLETED',
  CompletedWithConflicts = 'COMPLETED_WITH_CONFLICTS',
}
